import { Button, DialogOverlay, DialogOverlayActions, DialogOverlayFooter, TextField } from '@fs/zion-ui'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { editReservation } from '../../services/reservationsService'
import useNotifications from '../../hooks/useNotifications'

export default function EditUserReservationDialog({ reservation, ranId, onSuccess, ...overlay }) {
  const { t } = useTranslation()
  const { error } = useNotifications()
  const [personId, setPersonId] = useState(reservation.currentIndividualId)
  const [childId, setChildId] = useState(reservation.currentIndividualId)
  const [parent1Id, setParent1Id] = useState(reservation.currentSpouse1Id)
  const [parent2Id, setParent2Id] = useState(reservation.currentSpouse2Id)
  const [spouse1Id, setSpouse1Id] = useState(reservation.currentSpouse1Id)
  const [spouse2Id, setSpouse2Id] = useState(reservation.currentSpouse2Id)
  const idGroupType = getIdGroupType()

  function getIdGroupType() {
    if (reservation.ordinanceType === 'SEALING_TO_PARENTS') {
      return 'SEALING_TO_PARENTS'
    }
    if (reservation.ordinanceType === 'SEALING_TO_SPOUSE') {
      return 'COUPLE'
    }
    return 'INDIVIDUAL'
  }

  const onSubmit = () => {
    const requestBody = {
      type: idGroupType,
      personId,
      childId,
      parent1Id,
      parent2Id,
      spouse1Id,
      spouse2Id,
    }
    editReservation(reservation.ranId, requestBody)
      .then(() => {
        onSuccess()
      })
      .catch((err) => {
        error(t('reservations.edit.error', `Error editing reservation: ${err.message || ''}`), err)
      })
    overlay.close()
  }

  function getReservationFields() {
    switch (idGroupType) {
      case 'SEALING_TO_PARENTS':
        return (
          <>
            <TextField
              label={t('reservations.edit.childId', 'Child ID')}
              value={childId}
              onChange={(e) => setChildId(e.target.value)}
              placeholder="XXXX-XXX"
            />
            <TextField
              label={t('reservations.edit.parent1Id', 'Parent 1 ID')}
              value={parent1Id}
              onChange={(e) => setParent1Id(e.target.value)}
              placeholder="XXXX-XXX"
            />
            <TextField
              label={t('reservations.edit.parent2Id', 'Parent 2 ID')}
              value={parent2Id}
              onChange={(e) => setParent2Id(e.target.value)}
              placeholder="XXXX-XXX"
            />
          </>
        )
      case 'COUPLE':
        return (
          <>
            <TextField
              label={t('reservations.edit.spouse1Id', 'Spouse 1 ID')}
              value={spouse1Id}
              onChange={(e) => setSpouse1Id(e.target.value)}
              placeholder="XXXX-XXX"
            />
            <TextField
              label={t('reservations.edit.spouse2Id', 'Spouse 2 ID')}
              value={spouse2Id}
              onChange={(e) => setSpouse2Id(e.target.value)}
              placeholder="XXXX-XXX"
            />
          </>
        )
      default:
        return (
          <TextField
            label={t('personId', 'Person ID')}
            value={personId}
            onChange={(e) => setPersonId(e.target.value)}
            placeholder="XXXX-XXX"
          />
        )
    }
  }

  return (
    <DialogOverlay
      id="editReservationsDialogOverlay"
      {...overlay}
      title={t('reservations.edit', 'Edit Reservation')}
      size="sm"
    >
      {getReservationFields()}
      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Button onClick={onSubmit} emphasis="high">
            {t('action.save', 'Save')}
          </Button>
          <Button id="cancelEditUserReservationBtn" onClick={overlay.close}>
            {t('action.cancel', 'Cancel')}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}
